// 详情
<template>
  <div class="form-single-fragment" style="position: relative">
    <el-form
      ref="formData"
      :model="formData"
      class="full-width-input"
      :rules="rules"
      style="width: 100%"
      label-width="100px"
      size="small"
      label-position="right"
      @submit.native.prevent
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="生产车间：" prop="product_line">
            <el-select
              v-model="formData.product_line"
              placeholder="生产车间"
              clearable
              filterable
            >
              <el-option
                v-for="item in product_lineArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="生产总线：" prop="product_lineinfo">
            <el-select
              v-model="formData.product_lineinfo"
              placeholder="生产总线"
              clearable
              filterable
              multiple
            >
              <el-option
                v-for="item in product_lineinfoArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工序：" prop="processes_id">
            <el-select
              v-model="formData.processes_id"
              placeholder="工序"
              clearable
              filterable
            >
              <el-option
                v-for="item in processes_idArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="角色：" prop="role_id">
            <el-select
              v-model="formData.role_id"
              placeholder="角色"
              clearable
              filterable
            >
              <el-option
                v-for="item in roleArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button size="small" @click="diaClose" :plain="true">
              取 消
            </el-button>
            <el-button size="small" type="primary" @click="onSave">
              确 认
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "LabelModel",
  props: {
    row: Object,
  },
  data() {
    return {
      formData: {
        product_line: null,
        product_lineinfo: null,
        processes_id: null,
        role_id: null,
      },
      columnArr: [],
      rules: {},

      processes_idArr: [],
      roleArr: [],
      product_lineArr: [
        { id: 1, name: "电气车间" },
        { id: 2, name: "冲压车间" },
        { id: 3, name: "金工车间" },
        { id: 4, name: "总装车间" },
        { id: 5, name: "质检车间" },
        { id: 6, name: "仓库" },
        { id: 7, name: "技术部" },
      ],
      product_lineinfoArr: [
        { id: 1, name: "总装小线" },
        { id: 2, name: "总装中线" },
        { id: 3, name: "总装大线" },
      ],
    };
  },

  computed: {
    // isEdit () {
    //   return this.postId != null;
    // }
  },
  mounted() {},
  created() {
    if (this.row.id) {
      this.getInfo(this.row.id);
    }
    this.getProcesses_idArr();
    this.getRoleArr();
  },
  watch: {},
  methods: {
    getInfo(dataId) {
      let params = {
        datasourceId: "1712669759671111680",
        dataId,
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/viewByDatasourceId/" + "roleReport",
        "get",
        params
      );
      httpCall.then((res) => {
        this.formData = {
          ...res.data,
          product_lineinfo: res.data.product_lineinfo
            .split(",")
            .map((str) => parseFloat(str)),
        };
      });
    },
    getProcesses_idArr() {
      let params = {
        dictId: "1653768968319537152",
        filterDtoList: [
          // { filterType: 4, columnName: "id", columnValueList: [2, 4] },
        ],
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.processes_idArr = res.data;
      });
    },
    getRoleArr() {
      let params = { dictId: "1712702008873455616", filterDtoList: [] };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.roleArr = res.data;
      });
    },

    onSave() {
      let formData = {
        ...this.formData,
        product_lineinfo: this.formData.product_lineinfo.toString(),
      };
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            this.$emit("onUpdate", {
              masterData: formData,
            });
          } else {
            this.$emit("onAdd", {
              masterData: formData,
            });
          }
        } else {
          this.$message("请填写完整");
          return false;
        }
      });
    },
    diaClose() {
      this.$emit("diaClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.Subtable {
  padding: 0 25px;
  box-sizing: border-box;
}
</style>
<style>
.el-table td > .cell span {
  display: inline-block !important;
}
::v-deep .el-radio__input {
  display: inline-block !important;
}
</style>
